<template>
    <div class="fab" @click="toggleMenu">
        <div class="menu" v-if="isOpen">
            <div class="menu-item" @click="navigate('/profile')">
                <span>Profile</span>
            </div>
            <hr class="menu-divider"/>
            <div class="menu-item" @click="navigate('/chat_recom')">
                <span>Chat with Recommender</span>
            </div>
        </div>
        <div class="fab-icon">☰</div>
    </div>
</template>

<script>
export default {
    name: 'FloatingActionButton',
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        navigate(path) {
            this.$router.push(path)
            this.isOpen = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.fab {
    /* --- layout --- */
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;

    /* --- theme --- */
    background-color: #007bff;
    color: white;
    box-shadow: 0 2px 10px rgba(0,0,0,0.3);
    border-radius: 50%;
    font-size: 24px;
    cursor: pointer;
  }

  .menu {
    position: absolute;
    bottom: 60px;
    right: 0;

    /* --- theme --- */
    background-color: #222;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.3);

    .menu-divider {
        margin: 10px 0;
        border: 0.5px solid #444;
    }

    .menu-item {
        padding: 10px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        color: white;
        text-align: center;
        transition: background-color 0.2s ease;
    }
  }
</style>